'use client'
import {
  Card,
  Col,
  LoadMoreSection,
  Row,
  Separator,
  Skeleton,
} from '@repo/ui/components'
import React, { Fragment } from 'react'
import {
  useGetLoyaltyTransactionHistory,
  useUserAuthDetails,
} from '@repo/services'
import { RewardItem } from './reward.item'
import { RewardsEmptyState } from './rewards.empty-state'

export const RewardsContainer = () => {
  const { data: user } = useUserAuthDetails()
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetLoyaltyTransactionHistory({
      skip: 0,
      limit: 10,
      userID: user?.data?.id ?? 0,
    })
  const transactions =
    data?.pages?.flatMap((page) => page.data?.transactions || []) || []

  return (
    <Row className='min-h-screen items-start  mb-20 md:mb-0'>
      <Card withoutBorder className='flex-1'>
        <Col>
          {isLoading && (
            <div className='space-y-2'>
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
              <Skeleton className='w-full h-20' />
            </div>
          )}
          {transactions?.map((transaction, index) => (
            <Fragment key={transaction.id + '-' + index.toString()}>
              {index !== 0 && <Separator />}
              <RewardItem item={transaction} />
            </Fragment>
          ))}

          {(transactions || []).length === 0 && !isLoading && (
            <RewardsEmptyState />
          )}
          <LoadMoreSection
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            isLoading={isLoading}
          />
        </Col>
      </Card>
    </Row>
  )
}
